export default "__VITE_ASSET__a06f270c__"